// extracted by mini-css-extract-plugin
export var animationPosition = "Form-module--animationPosition--27jU2";
export var animationWrapper = "Form-module--animationWrapper--PFbRQ";
export var btn = "Form-module--btn--523Kz";
export var form = "Form-module--form--TbUDq";
export var inputInt = "Form-module--inputInt--M3SES";
export var inputSpan = "Form-module--inputSpan--NTB0e";
export var inputText = "Form-module--inputText--GoMAJ";
export var invalidInputSpan = "Form-module--invalidInputSpan--TBK5i";
export var invalidText = "Form-module--invalidText--8HMly";
export var invalidTextWrapper = "Form-module--invalidTextWrapper--hPOta";
export var mainForm = "Form-module--mainForm--SUO+f";
export var numberInput = "Form-module--numberInput--NZTBV";
export var title = "Form-module--title--5+YNm";
export var vsBG = "Form-module--vsBG--YolcE";